(function () {
  /**
   * List of callbacks.
   *
   * @type {{}}
   */
  const queue = {};

  /**
   * Add callback to queue.
   *
   * @param name
   * @param callback
   */
  const addCallback = function (name, callback) {
    if (typeof queue[name] === 'undefined') {
      queue[name] = [];
    }

    queue[name].push(callback);
    if (queue[name].length === 1) {
      performNext(name);
    }
  };

  /**
   * Perform next callback from queue.
   *
   * @param name
   */
  const performNext = function (name) {
    if (queue[name].length === 0) {
      return;
    }

    let promise = queue[name][0]();
    if (typeof promise === 'undefined' || typeof promise.always !== 'function') {
      const deferred = $.Deferred();
      deferred.resolve();
      promise = deferred.promise();
    }

    promise.then(() => {
      queue[name].shift();
      performNext(name);
    });
  };

  window.promiseQueue = {
    add: addCallback,
  };
}());
